import axios, { addInterceptors } from './interceptor-axios';
import config from '~/config';

class ElementService {
  constructor(token) {
    const headers = {};
    if (token) {
      headers.Authorization = token;
    }
    this.axios = axios.create({
      baseURL: config.apiDataURL,
      headers,
    });
    addInterceptors(this.axios);
  }

  listElements = ({ categoryIDs, categoryID, page, max_results }) => {
    const request = {
      method: 'GET',
      url: '/elements',
      params: {
        categoryIDs: categoryIDs && categoryIDs.join(','),
        category_id: categoryID,
        page,
        max_results: max_results || 30,
      },
    };
    return this.axios(request);
  };

  insertDbOfElement = (params) => {
    const { uploadKeys, subCat } = params;
    const request = {
      method: 'POST',
      url: '/elements',
      data: {
        elements: uploadKeys,
        category_id: subCat,
      },
    };
    return this.axios(request);
  };

  deleteElement = (id) => {
    const request = {
      method: 'DELETE',
      url: '/elements',
      data: {
        id,
      },
    };
    return this.axios(request);
  };

  getUrlOfItem = (id) => {
    const request = {
      method: 'POST',
      url: '/elements/download',
      data: {
        id,
      },
    };
    return this.axios(request);
  };
}

export default new ElementService();
